import React from 'react'
import ReactTable from '@dhn/components/molecules/data-table'
import { Col, FormGroup, Input, Label, Row } from 'reactstrap'
import EnabledButton from '../../../../../../../../../../@dhn/components/molecules/button-enabled';
import ReactFormat from "react-number-format";
import TimeInput12h from '@dhn/components/molecules/time-input-12h';

// Un día solo puede estar activo si tiene hora desde y hasta.
const hasBothHours = (fromHour, toHour) => Boolean(fromHour && toHour);

export default function Schedule({ averageAppoimentTime, sheduleHeader, schedulingFormat, onChange, scheduleSelected }) {
  // Activa el día al completar ambas horas y lo desactiva si se borra una.
  const onChangeHour = (row, field, value) => {
    onChange(row.weekDay, value, field, true);

    const nextRow = { ...row, [field]: value };
    const canEnable = hasBothHours(nextRow.fromHour, nextRow.toHour);
    if (canEnable !== Boolean(row.enabled))
      onChange(row.weekDay, canEnable, 'enabled', true);
  };

  return (
    <div className="animated fadeIn">

      <Row form className='d-flex justify-content-center align-items-center mt-4'>
        <Label style={{ fontSize: "16px", fontFamily: 'revert-layer' }}>
          <strong> {sheduleHeader}</strong>
        </Label>
      </Row>
      {schedulingFormat === 2 &&
        <Row form>
          <Col md={2}>
            <Label>
              Tiempo Promedio por Cita:
            </Label>
            <ReactFormat
              className="my-1 text-right"
              placeholder="Minutos"
              value={averageAppoimentTime || ""}
              customInput={Input}
              allowNegative={false}
              decimalScale={0}
              onValueChange={({ floatValue }) => onChange('averageAppoimentTime', floatValue, 'medicalSelected')
              }
            />
          </Col>
        </Row>
      }
      <Row form>
        <Col>
          <ReactTable
            data={scheduleSelected}
            defaultPageSize={7}
            className=' -highlight mt-2'
            columns={[{
              Header: 'Día',
              accessor: 'label'
            }, {
              Header: 'Desde',
              className: 'py-0 text-center',
              Cell: ({ original }) => (
                <TimeInput12h
                  value={original.fromHour}
                  onChange={(value) => onChangeHour(original, 'fromHour', value)}
                />
              )

            }, {
              Header: 'Hasta',
              className: 'py-0 text-center',
              Cell: ({ original }) => {
                return (
                  <TimeInput12h value={original.toHour} onChange={(value) => onChangeHour(original, 'toHour', value)} />
                )
              }
            }, {
              Header: 'Opciones',
              accessor: 'enabled',
              Cell: ({ original: { enabled, weekDay, fromHour, toHour } }) => {
                const canEnable = hasBothHours(fromHour, toHour);
                return (
                  <FormGroup>
                    <EnabledButton
                      status={enabled}
                      disabled={!enabled && !canEnable}
                      title={!enabled && !canEnable ? 'Indique la hora desde y hasta para activar este día.' : undefined}
                      onClick={() => {
                        onChange(weekDay, !enabled, 'enabled', true)
                      }
                      }
                    />

                  </FormGroup>
                )
              }
            }]}
          />
        </Col>
      </Row>
    </div>
  )
}
